// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.cell_QPweH {
  border-right : 1px solid rgba(0,0,0,0.1);
  position : absolute;
  top : 0;
  bottom : 0;
}

.background_IJWSa {
  position : absolute;
  top : 0;
  bottom : 0;
  left : 0;
  right : 0;
  overflow : hidden;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/MomentBackground.css"],"names":[],"mappings":";AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,iBAAiB;AACnB","sourcesContent":["\n.cell {\n  border-right : 1px solid rgba(0,0,0,0.1);\n  position : absolute;\n  top : 0;\n  bottom : 0;\n}\n\n.background {\n  position : absolute;\n  top : 0;\n  bottom : 0;\n  left : 0;\n  right : 0;\n  overflow : hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `cell_QPweH`,
	"background": `background_IJWSa`
};
export default ___CSS_LOADER_EXPORT___;
